import React, {Component} from 'react';
import {connect, dispatch} from 'react-redux';
import {bindActionCreators} from 'redux';
import Typekit from 'react-typekit';

import {fetchCategories, ROUTER} from '../actions/index';

import Header from '../components/header';
import Map from '../components/map';
import List from '../components/list';
import Footer from '../components/footer';
import NavBar from './parts/NavBar';
import Menu from '../components/menu';


class Mapper extends Component {
    constructor(props) {
	    super(props);
	    this.state = {
		    mapView: true
		};
	    // This binding is necessary to make `this` work in the callback
	    this.handleClick = this.handleClick.bind(this);
	}
	
	handleClick(){
		console.log(this);
		//console.log(this);
		this.setState(state => ({
	      mapView: !state.mapView
	    }));
	}

    
    componentWillMount() {
        if (this.props.location.search){
        	this.props.fetchCategories(this.props.location.search.replace("?category=" , ""));
        }
        this.props.dispatch({
           type: ROUTER,
           payload: this.props.match
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match.params.pageNum !== nextProps.match.params.pageNum || this.props.location.pathname !== nextProps.location.pathname) {
            if (this.props.location.search){
            	this.props.fetchCategories(this.props.location.search.replace("?category=" , ""));
            }
            this.props.dispatch({
                type: ROUTER,
                payload: nextProps.match
            });
        }
    }

    componentDidUpdate() {
        document.title = this.props.cat.name;
    }
    

    render() {
       var category = this.props.location.search.replace("?category=" , "");
       let category_array = category.split('-');
       var count = category_array.length - 1;
       console.log(count);
       var i = 0;
       category_array.forEach(function(element) {
	       if( i == 0 ){
		       category = element;
	       } else if ( i < parseInt(count) ) { 
	       	  	category = category + ", " + element;
	       } else {
		   		category = category + " & " + element;
	       }
	       i++;
       });
       console.log(category);
       return (
            <section className="kiosk-wrapper">
                <Typekit kitId="eab1tpm" />
                <Header/>
                <div className="title-block">
					<div className="nav-back">
                		<a href={'/explore-chester-county/'}>{'<'}</a>
					</div>
					<h1>{ category }</h1>
					<br />
					<button className="btn-text" type="button" onClick={this.handleClick}><span>{ !this.state.mapView ? "List View" : "Map View"}</span> | { this.state.mapView ? "List View" : "Map View"}</button>
					<Menu items={this.props.cat} />
				</div>
                { this.state.mapView ? <Map /> : <List /> }
                <NavBar name="footer_menu"/>
            </section>
        );

    }
}

function mapStateToProps(state) {
	return {
		cat: state.cat,
		selectedCat: state.selectedCat
	};
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({fetchCategories, dispatch}), dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Mapper)


// WEBPACK FOOTER //
// ./src/containers/mapper.js